export enum PublishStatusEnum {
  CANCEL = -1,
  WAIT,
  SUCC,
}

export const PublishStatusMap = new Map([
  [PublishStatusEnum.CANCEL, '已取消'],
  [PublishStatusEnum.WAIT, '等待发送'],
  [PublishStatusEnum.SUCC, '已发送'],
]);

export enum UserEnum {
  '全部用户',
  // '首登新用户',
  '7天内未登录用户' = 2,
  '30天内未登录用户',
  // '周活用户',
  '未参与过活动的用户' = 5,
}

enum RewardTypeEnum {
  Coins = 1,
  Givs = 2,
}

export const RewardTypeEnumMap = new Map([
  [RewardTypeEnum.Coins, '充值金币'],
  [RewardTypeEnum.Givs, '活动金币'],
]);
